import React from 'react'
import { Tooltip, IconButton } from '@mui/material'
import { Web, Description } from '@mui/icons-material'
import { FaGithub, FaLinkedin, FaDribbble } from 'react-icons/fa'
import { Nullable } from 'types/global'
import useStyles from './styles'

export interface ISocialLinkProps {
  url: Nullable<string>
  type: string
  error?: Nullable<string>
}

function SocialLink(props: ISocialLinkProps) {
  const { classes } = useStyles()
  const { url, type, error } = props

  if (url) {
    if (type === 'Website or Blog') {
      return (
        <a href={url} target="_blank" rel="noopener noreferrer" data-cy="website-blog">
          <Tooltip title={`${type}`}>
            <IconButton className={classes.iconButton}>
              <Web className={error ? classes.hasError : undefined} />
            </IconButton>
          </Tooltip>
        </a>
      )
    }

    if (type === 'Github') {
      return (
        <a href={url} target="_blank" rel="noopener noreferrer" data-cy="github">
          <Tooltip title={`${type} profile`}>
            <IconButton className={classes.iconButton}>
              <FaGithub className={error ? classes.hasError : undefined} />
            </IconButton>
          </Tooltip>
        </a>
      )
    }

    if (type === 'LinkedIn') {
      return (
        <a href={url} target="_blank" rel="noopener noreferrer" data-cy="linkedin">
          <Tooltip title={`${type} profile`}>
            <IconButton className={classes.iconButton}>
              <FaLinkedin className={error ? classes.hasError : undefined} />
            </IconButton>
          </Tooltip>
        </a>
      )
    }

    if (type === 'Dribbble') {
      return (
        <a href={url} target="_blank" rel="noopener noreferrer" data-cy="dribbble">
          <Tooltip title={`${type} profile`}>
            <IconButton className={classes.iconButton}>
              <FaDribbble className={error ? classes.hasError : undefined} />
            </IconButton>
          </Tooltip>
        </a>
      )
    }

    if (type === 'Resume') {
      return (
        <a href={url} target="_blank" rel="noopener noreferrer" data-cy="resume">
          <Tooltip title="Résumé/CV">
            <IconButton className={classes.iconButton}>
              <Description className={error ? classes.hasError : undefined} />
            </IconButton>
          </Tooltip>
        </a>
      )
    }
  }

  return null
}

export default React.memo(SocialLink)
